import { createSelector } from 'reselect';
import merge from 'lodash/merge';
import dayjs from 'core/utils/dayjs';
import { selectCurrentDate } from 'core/selectors/env';

export const selectRecentMemberOrders = state => state.recentMemberOrders;

export const selectRecentMemberOrdersConfig = createSelector(
  [selectRecentMemberOrders, selectCurrentDate],
  ({ config }, currentDate) => (
    merge({}, config, {
      api: {
        params: {
          transaction_start_date: dayjs(currentDate).subtract(3, 'months').format('YYYY-MM-DD'),
        },
      },
    })
  ),
);

export const selectRecentMemberOrdersIsLoading = createSelector(
  selectRecentMemberOrders,
  recentMemberOrders => recentMemberOrders.isLoading,
);

export const selectRecentMemberOrdersIsLoaded = createSelector(
  selectRecentMemberOrders,
  recentMemberOrders => recentMemberOrders.isLoaded,
);

export const selectRecentMemberOrdersRecords = createSelector(
  selectRecentMemberOrders,
  recentMemberOrders => recentMemberOrders.memberOrders,
);

export const selectRecentMemberOrdersPendingRecords = createSelector(
  selectRecentMemberOrders,
  recentMemberOrders => recentMemberOrders.memberOrdersPending,
);
